import Accordion2 from '../Atoms/Accordion'
import faqsMarkdownEN from '../Atoms/Accordion/faqsCicloBono_en.md'
import faqsMarkdownES from '../Atoms/Accordion/faqsCicloBono_es.md'

import React, { useEffect, useState } from 'react'

import classNames from 'classnames'
import RichText from 'components/Atoms/RichText'
import { useTranslation } from 'react-i18next'

export interface FaqsCicloBono2Props {
  className?: string
  titleClassName?: string
}

const FaqsCicloBono2: React.FC<FaqsCicloBono2Props> = ({
  className,
  titleClassName,
}) => {
  const { t, i18n } = useTranslation('ciclo-bono')
  const [markdownContent, setMarkdownContent] = useState<string>('')

  useEffect(() => {
    // Fetch the markdown content based on the current language
    fetch(i18n.language === 'es' ? faqsMarkdownES : faqsMarkdownEN)
      .then(response => response.text())
      .then(text => {
        setMarkdownContent(text)
      })
      .catch(error => console.error('Error loading markdown:', error))
  }, [i18n.language]) // Re-run when language changes

  const containerClasses = classNames('max-w-screen-xl', className)

  const titleClasses = classNames(
    'text-2xl md:text-3xl font-bold mb-8',
    'sm:w-4/5',
    titleClassName,
  )

  return (
    <div className="relative z-10 flex flex-col-reverse lg:flex-row md:space-x-24">
      <div className="basis-full sm:basis-4/6 p-4 sm:p-0 space-y-4 sm:mt-0">
        <section className={containerClasses}>
          <h2 className={titleClasses}>
            <RichText boldClassName="text-blue-800" content={t('faqs.title')} />
          </h2>
          <div className="basis-full sm:hidden flex justify-center items-center mb-6">
            <img
              className="w-4/5 sm:w-full"
              src={`${process.env.REACT_APP_URL_S3}/images/CicloBonoKnowledge_new2.png`}
              alt="mainImage"
            />
          </div>
          <div className="max-w-3xl mx-auto">
            {markdownContent && (
              <Accordion2 markdownContent={markdownContent} />
            )}
          </div>
        </section>
      </div>
      <div className="basis-full hidden sm:flex sm:basis-2/6 justify-center items-start">
        <img
          className="w-4/5 sm:w-full"
          src={`${process.env.REACT_APP_URL_S3}/images/CicloBonoKnowledge_new2.png`}
          alt="mainImage"
        />
      </div>
    </div>
  )
}

export default FaqsCicloBono2
